import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { Request } from '../../../httpClient/serverApi/requests/Request';

export interface IUpdateUserDisplayNameParams {
  userId: string; // server user id
  displayName: string;
}

export class UpdateUserDisplayNameRequest extends Request<IUpdateUserDisplayNameParams, IResult> {
  constructor(params: IUpdateUserDisplayNameParams) {
    super('updateUserDisplayName', params);
  }
}
